// Header Image
import header from "../assets/header.jpg";

// Header Section
const Header = () => {
    return(
        <header>
            <img src={header} alt="Medicine ball training" />
        </header>
    );
    
}

export default Header;